var _path, _rect, _g, _path2, _rect2, _g2, _path3, _rect3, _g3, _path4, _rect4, _g4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFullscreenWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.60189 8.04305L7.58167 7.02283L5.87183 5.31299",
    stroke: "white",
    strokeWidth: 0.9
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_458_29681",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 12,
    height: 12
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 4.28873,
    height: 11.1221,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 11.7114 3.58569)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_458_29681)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5683 5.13203L5.69194 5.13203L5.69194 12.0084",
    stroke: "white",
    strokeWidth: 0.9
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.475 8.08338L16.5389 7.01941L18.2488 5.30957",
    stroke: "white",
    strokeWidth: 0.9
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_458_29681",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 12,
    height: 12
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 4.28873,
    height: 11.1221,
    transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 19.9746 11.1501)",
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_458_29681)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4285 12.007L18.4285 5.13066L11.5521 5.13066",
    stroke: "white",
    strokeWidth: 0.9
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.478 14.9153L16.5399 15.9772L18.2498 17.687",
    stroke: "white",
    strokeWidth: 0.9
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_458_29681",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 11,
    width: 12,
    height: 12
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 4.28873,
    height: 11.1221,
    transform: "matrix(0.707107 0.707107 0.707107 -0.707107 12.4104 19.4146)",
    fill: "#D9D9D9"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_458_29681)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5535 17.868L18.4299 17.868L18.4299 10.9916",
    stroke: "white",
    strokeWidth: 0.9
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.61245 14.9483L7.58216 15.9786L5.87232 17.6885",
    stroke: "white",
    strokeWidth: 0.9
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_458_29681",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 11,
    width: 12,
    height: 12
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 4.28873,
    height: 11.1221,
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 4.14648 11.8489)",
    fill: "#D9D9D9"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_458_29681)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.69258 10.992L5.69258 17.8684L12.569 17.8684",
    stroke: "white",
    strokeWidth: 0.9
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullscreenWhite);
export default __webpack_public_path__ + "static/media/fullscreen-white.bd8417f68e0835c785ef89a661543a9f.svg";
export { ForwardRef as ReactComponent };